import SHA256 from 'crypto-js/sha256';
import api from './api';
import { setStorage, removeStorage } from './localstorage';

export const login = async (username, password, taxId, typeTax) => {
  try {
    if (typeTax === 'citizen') {
      const hashTaxId = SHA256(taxId).toString();
      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/auth/login/citizen`,
        {
          username,
          password,
          taxId,
          hashTaxId,
        },
      );
      const token = data?.token;
      await setStorage('token', token);
      await setStorage('name', `${data.name}`);
      await setStorage('statusSO', 'Open');
      await setStorage('accesstoken', data.accesstoken);
    } else if (typeTax === 'business') {
      const hashTaxId = SHA256(taxId).toString();
      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/auth/login/business`,
        {
          username,
          password,
          taxId,
          hashTaxId,
        },
      );
      const token = data?.token;
      await setStorage('token', token);
      await setStorage('name', `${data.name}`);
      await setStorage('statusSO', 'Open');
      await setStorage('accesstoken', data.accesstoken);
    }
    //   await setStorage('remember', JSON.stringify(remember));
  } catch (e) {
    throw new Error(e);
  }
};

export const loginAdmin = async (username, password) => {
  try {
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL_admin}/auth/login/admin`,
      {
        username,
        password,
      },
    );

    const token = data?.token;
    // console.log('data', token);
    await setStorage('token', token);
    await setStorage('name', `${data.name}`);
    await setStorage('merchant_name', `${data.merchant_name}`);
    await setStorage('statusSO', 'Open');
    await setStorage('accesstoken', data.accesstoken);
  } catch (e) {
    throw new Error(e);
  }
};

export const logout = async () => {
  removeStorage('token');
  removeStorage('name');
  removeStorage('remember');
  removeStorage('statusSO');
  removeStorage('accesstoken');
};
